import css from "./TagsBar.module.scss";
import { TagsIcons } from "components";
import type { ProjectData } from "router/handleProjetsData";

export const TagsBar = ({ tags }: { tags: ProjectData["tags"] }) => {
	return (
		<div className={css._}>
			{tags.map((tag, key) => {
				const tagLogo = getTagLogo(tag);
				return (
					<div key={key} className={css.tag}>
						<div className={css.tagLogo}>{tagLogo}</div>
						<span className={css.tagName}>{tag}</span>
					</div>
				);
			})}
		</div>
	);
};
function getTagLogo(tag: string) {
	const TagLogo = TagsIcons[tag];
	return TagLogo ? <TagLogo /> : tag[0].toUpperCase();
}
